export default __webpack_public_path__ + "img/servicesupport.d76251dc.png";